import React from "react";

interface Props {
  size?: number;
}

function ChevronRightIcon({ size = 16 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 17 18"
    >
      <path stroke="currentColor" d="M8.533 17L16 9 8.533 1"></path>
    </svg>
  );
}

export default ChevronRightIcon;
